import React from 'react';
import { Info } from 'lucide-react';
import { clsx } from 'clsx';

// A "why this matters" hover overlay for negative insights. The PARENT must be
// positioned `group relative overflow-hidden` — on hover the message fades in
// over the parent's content (clipped to its bounds, so no positioning fuss).
export const HoverTip: React.FC<{ tip: string; theme?: 'light' | 'dark' }> = ({ tip, theme = 'dark' }) => {
  const isLight = theme !== 'dark';
  return (
    <>
      <span className={clsx('absolute top-3 right-3 z-10', isLight ? 'text-slate-300' : 'text-slate-500')}>
        <Info size={15} />
      </span>
      <div
        className={clsx(
          'absolute inset-0 z-20 flex items-center p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none',
          isLight ? 'bg-white' : 'bg-slate-900'
        )}
      >
        <p className={clsx('text-[11px] leading-relaxed font-medium', isLight ? 'text-slate-700' : 'text-slate-200')}>
          {tip}
        </p>
      </div>
    </>
  );
};
